import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { filter, map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../core/services/auth.service';
import { StoreService } from '../../../core/services/store.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterLink],
  template: `
    <footer class="border-t border-surface-200 bg-surface-0" [class.mt-16]="!inAdmin()">
      <!-- Plataforma (fora do painel): marca e atalhos -->
      @if (!inStore() && !inAdmin()) {
        <div class="mx-auto grid max-w-7xl gap-10 px-4 py-12 sm:px-6 md:grid-cols-[2fr_1fr_1fr]">
          <div>
            <a routerLink="/" class="flex items-center gap-2.5 text-lg font-extrabold text-surface-900">
              <img src="logo.png" alt="" class="h-8 w-auto" />
              <span>{{ platformName }}</span>
            </a>
            <p class="mt-4 max-w-sm leading-relaxed text-muted-color">
              A loja online do seu negócio: catálogo, pedidos, entregas e avisos no WhatsApp, tudo num só lugar.
            </p>
          </div>
          <nav aria-label="Produto">
            <p class="text-sm font-bold text-surface-900">Produto</p>
            <ul class="mt-4 space-y-3 text-sm">
              <li><a routerLink="/" fragment="beneficios" class="text-muted-color transition-colors hover:text-primary">Recursos</a></li>
              <li><a routerLink="/" fragment="planos" class="text-muted-color transition-colors hover:text-primary">Planos</a></li>
              <li><a routerLink="/" fragment="duvidas" class="text-muted-color transition-colors hover:text-primary">Dúvidas</a></li>
            </ul>
          </nav>
          <nav aria-label="Acesso">
            <p class="text-sm font-bold text-surface-900">Acesso</p>
            <ul class="mt-4 space-y-3 text-sm">
              <li><a routerLink="/cadastro" class="text-muted-color transition-colors hover:text-primary">Criar a minha loja</a></li>
              <li><a routerLink="/entrar" class="text-muted-color transition-colors hover:text-primary">Entrar no painel</a></li>
            </ul>
          </nav>
        </div>
      }

      <div class="border-t border-surface-200" [class.border-t-0]="inStore() || inAdmin()">
        <div class="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-6 text-sm text-muted-color sm:flex-row sm:px-6">
          <p>© {{ year }} {{ ownerName() }}. Todos os direitos reservados.</p>
          @if (inStore()) {
            <p>Loja criada com <a routerLink="/" class="font-semibold text-surface-700 transition-colors hover:text-primary"> {{ platformName }}</a></p>
          }
        </div>
      </div>
    </footer>
  `
})
export class FooterComponent {
  private authService = inject(AuthService);
  private storeService = inject(StoreService);
  private router = inject(Router);

  platformName = environment.platformName;
  year = new Date().getFullYear();

  inStore = computed(() => this.authService.storeSlug() !== null);
  // No painel o rodapé fica só com a linha de direitos
  inAdmin = toSignal(
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => this.router.url.startsWith('/admin'))
    ),
    { initialValue: location.pathname.startsWith('/admin') }
  );
  // Na vitrine o rodapé é da loja; no resto, da plataforma
  ownerName = computed(() => (this.inStore() ? this.storeService.store()?.name : null) ?? this.platformName);
}
